import React, { useState } from "react";
import GlobalModalComponent from "../../../../shared/globalModal/GlobalModalComponent";
import logo from "../../../../../assets/images/site-logo/Logo.png";
import CloseIcon from "../../../../../assets/images/pages/login/CloseButton.svg";
import styles from "./ChangePassword.module.scss";
import MainButton from "../../../../shared/button/MainButton";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CloseLeft from "../../../../../assets/images/pages/login/CaretLeft.svg";
import InputComponent from "../../../../shared/input/InputComponent";

import {
  setIsChangePassword,
  setIsForgetPassword,
  setIsLogin,
  setIsMessage,
  setIsOtp,
  setIsUserStatus,
  setMessageType,
} from "../../../../../redux/Slices/userSlice";
import { changePassword } from "../../../../../services/auth.service";
import { RootState } from "../../../../../redux/store";

const ChangePassword = () => {
  const dispatch = useDispatch();
  const otpSession = useSelector((state: RootState) => state.user.otpSession);
  const [isModal, setIsModal] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isShowNewPassword, setIsShowNewPassword] = useState(false);
  const [isShowConfirmPassword, setIsShowConfirmPassword] = useState(false);
  const { data } = useSelector((state: RootState) => state.translationData);

  const [error, setError] = useState<{
    password?: string;
    password_confirmation?: string;
  }>({});

  const navigate = useNavigate();
  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    if (name === "newPassword") {
      setNewPassword(value);
    } else if (name === "confirmPassword") {
      setConfirmPassword(value);
    }
  };

  const LoginClose = () => {
    setIsModal(false);
    setIsForgetPassword(false);
    setIsLogin(false);
    setIsOtp(false);
    setIsChangePassword(false);
    setIsUserStatus(false);
    setIsMessage(false);
  };

  const handleSubmit = async () => {
    try {
      const response = await changePassword(otpSession, {
        password: newPassword,
        password_confirmation: confirmPassword,
      });

      if (response.status === 200) {
        dispatch(setIsForgetPassword(false));
        dispatch(setIsLogin(true));
        dispatch(setIsOtp(false));
        dispatch(setIsChangePassword(false));
        dispatch(setIsMessage(true));
        dispatch(setMessageType("changePassword"));
        navigate("/auth");
      }
    } catch (error: any) {
      const errorData = error.response?.data?.content || {};
      setError({
        password: errorData.password,
        password_confirmation: errorData.password_confirmation,
      });
    }
  };

  return (
    <GlobalModalComponent isOpen={true} onClose={LoginClose}>
      <div className={styles.loginModal}>
        <div className={styles.headerLogin}>
          <Link to={"/"} onClick={LoginClose} className={styles.closeButton}>
            <img
              className={styles.closeIcon}
              src={CloseIcon}
              alt="EyeIcon"
              onClick={LoginClose}
            />
          </Link>
        </div>
        <div className={styles.modalContainer}>
          <div className={styles.logo}>
            <img src={logo} alt="colibri" />
          </div>
          <h3 className={styles.loginTitle}>Şifrəni Yenilə</h3>

          <div className={styles.inputContainer}>
            <InputComponent
              label={data?.auth_common_new_password}
              type="password"
              name="newPassword"
              value={newPassword}
              onChange={handleInputChange}
              placeholder={data?.auth_common_new_password}
              error={error.password}
              isPassword={true}
              isShowPassword={isShowNewPassword}
              toggleShowPassword={() =>
                setIsShowNewPassword(!isShowNewPassword)
              }
            />

            <InputComponent
              label={data?.auth_common_repeat_password}
              type="password"
              name="confirmPassword"
              value={confirmPassword}
              onChange={handleInputChange}
              placeholder={data?.auth_common_repeat_password}
              error={error.password_confirmation}
              isPassword={true}
              isShowPassword={isShowConfirmPassword}
              toggleShowPassword={() =>
                setIsShowConfirmPassword(!isShowConfirmPassword)
              }
            />
            <MainButton
              text="Şifrəni Dəyişdir"
              type="button"
              className={styles.buttonLogin}
              onClick={handleSubmit}
            />
          </div>
        </div>
      </div>
    </GlobalModalComponent>
  );
};

export default ChangePassword;
